export class ColorConstants {
  // New Primary Colours
  public static readonly GREY_25 = "#f4f5f5";

  public static readonly GREY_50 = "#e9eaeb";

  public static readonly GREY_100 = "#d5d6d8";

  public static readonly GREY_200 = "#abacb1";

  public static readonly GREY_300 = "#808389";

  public static readonly GREY_400 = "#565962";

  public static readonly GREY_500 = "#2c303b";

  public static readonly GREY_500_RGB = "44, 48, 59";

  public static readonly GREY_600 = "#23262f";

  public static readonly GREY_700 = "#1a1d23";

  public static readonly GREY_800 = "#121318";

  public static readonly GREY_900 = "#090a0c";

  public static readonly INDIGO_25 = "#f5f5f8";

  public static readonly INDIGO_50 = "#e9e9ee";

  public static readonly INDIGO_100 = "#d4d3de";

  public static readonly INDIGO_200 = "#a9a7be";

  public static readonly INDIGO_300 = "#7e7c9d";

  public static readonly INDIGO_400 = "#53507d";

  public static readonly INDIGO_500 = "#28245c";

  public static readonly INDIGO_500_RGB = "40, 36, 92";

  public static readonly INDIGO_600 = "#201d4a";

  public static readonly INDIGO_700 = "#181637";

  public static readonly INDIGO_800 = "#100e25";

  public static readonly INDIGO_900 = "#080712";

  public static readonly BLUE_25 = "#f7f8fd";

  public static readonly BLUE_50 = "#eff1fb";

  public static readonly BLUE_100 = "#e0e4f8";

  public static readonly BLUE_200 = "#c2c9f0";

  public static readonly BLUE_300 = "#a3afe9";

  public static readonly BLUE_400 = "#8594e1";

  public static readonly BLUE_500 = "#6679da";

  public static readonly BLUE_600 = "#5261ae";

  public static readonly BLUE_700 = "#3d4983";

  public static readonly BLUE_800 = "#293057";

  public static readonly BLUE_900 = "#111528";

  public static readonly RED_25 = "#fdf4f4";

  public static readonly RED_50 = "#fbe8e9";

  public static readonly RED_100 = "#f7d2d4";

  public static readonly RED_200 = "#efa5aa";

  public static readonly RED_300 = "#e7797f";

  public static readonly RED_400 = "#df4c55";

  public static readonly RED_500 = "#d71f2a";

  public static readonly RED_600 = "#ac1922";

  public static readonly RED_700 = "#811319";

  public static readonly RED_800 = "#560c11";

  public static readonly RED_900 = "#220507";

  public static readonly CORAL_25 = "#fff9f7";

  public static readonly CORAL_50 = "#fff2ee";

  public static readonly CORAL_100 = "#ffe7df";

  public static readonly CORAL_200 = "#ffcfbe";

  public static readonly CORAL_300 = "#ffb69e";

  public static readonly CORAL_400 = "#ff9e7d";

  public static readonly CORAL_500 = "#ff865d";

  public static readonly CORAL_600 = "#cc5b35";

  public static readonly CORAL_700 = "#994529";

  public static readonly CORAL_800 = "#662e1b";

  public static readonly CORAL_900 = "#33170e";

  public static readonly GREEN_25 = "#f8fcfa";

  public static readonly GREEN_50 = "#f1f8f4";

  public static readonly GREEN_100 = "#e4f1ea";

  public static readonly GREEN_200 = "#c9e4d5";

  public static readonly GREEN_300 = "#aed6c0";

  public static readonly GREEN_400 = "#93c9ab";

  public static readonly GREEN_500 = "#78bb96";

  public static readonly GREEN_500_RGB = "120, 187, 150";

  public static readonly GREEN_600 = "#609678";

  public static readonly GREEN_700 = "#48705a";

  public static readonly GREEN_800 = "#2a4234";

  public static readonly GREEN_900 = "#10271a";

  // New Secondary Colours
  public static readonly VIOLET_25 = "#f8f7fd";

  public static readonly VIOLET_50 = "#f1effb";

  public static readonly VIOLET_100 = "#e3e0f7";

  public static readonly VIOLET_200 = "#c7c0f0";

  public static readonly VIOLET_300 = "#aaa1e8";

  public static readonly VIOLET_400 = "#8e81e1";

  public static readonly VIOLET_500 = "#7262d9";

  public static readonly VIOLET_600 = "#5b4eae";

  public static readonly VIOLET_700 = "#443b82";

  public static readonly VIOLET_800 = "#2e2757";

  public static readonly VIOLET_900 = "#17142b";

  public static readonly SKY_BLUE_25 = "#f6fafe";

  public static readonly SKY_BLUE_50 = "#edf6fc";

  public static readonly SKY_BLUE_100 = "#dcedf9";

  public static readonly SKY_BLUE_200 = "#b9daf4";

  public static readonly SKY_BLUE_300 = "#95c8ee";

  public static readonly SKY_BLUE_400 = "#72b5e9";

  public static readonly SKY_BLUE_500 = "#4fa3e3";

  public static readonly SKY_BLUE_600 = "#3f82b6";

  public static readonly SKY_BLUE_700 = "#2f6288";

  public static readonly SKY_BLUE_800 = "#20415b";

  public static readonly SKY_BLUE_900 = "#10212d";

  public static readonly AQUA_25 = "#f5fbfc";

  public static readonly AQUA_50 = "#ebf6f9";

  public static readonly AQUA_100 = "#d8edf2";

  public static readonly AQUA_200 = "#b1dbe5";

  public static readonly AQUA_300 = "#89cad9";

  public static readonly AQUA_400 = "#62b8cc";

  public static readonly AQUA_500 = "#3ba6bf";

  public static readonly AQUA_600 = "#2f8599";

  public static readonly AQUA_700 = "#236473";

  public static readonly AQUA_800 = "#18424c";

  public static readonly AQUA_900 = "#0c2126";

  public static readonly MINT_GREEN_25 = "#f7fcfa";

  public static readonly MINT_GREEN_50 = "#eff9f5";

  public static readonly MINT_GREEN_100 = "#e0f3ec";

  public static readonly MINT_GREEN_200 = "#c1e7d8";

  public static readonly MINT_GREEN_300 = "#a1dcc5";

  public static readonly MINT_GREEN_400 = "#82d0b1";

  public static readonly MINT_GREEN_500 = "#63c49e";

  public static readonly MINT_GREEN_600 = "#4f9d7e";

  public static readonly MINT_GREEN_700 = "#3b765f";

  public static readonly MINT_GREEN_800 = "#284e3f";

  public static readonly MINT_GREEN_900 = "#142720";

  public static readonly GOLDENROD_25 = "#fefbf5";

  public static readonly GOLDENROD_50 = "#fcf7ec";

  public static readonly GOLDENROD_100 = "#f9f0d9";

  public static readonly GOLDENROD_200 = "#f4e1b3";

  public static readonly GOLDENROD_300 = "#eed18d";

  public static readonly GOLDENROD_400 = "#e9c267";

  public static readonly GOLDENROD_500 = "#e3b341";

  public static readonly GOLDENROD_600 = "#b68f34";

  public static readonly GOLDENROD_700 = "#886b27";

  public static readonly GOLDENROD_800 = "#5b481a";

  public static readonly GOLDENROD_900 = "#2d240d";

  public static readonly AMBER_ORANGE_25 = "#fef9f5";

  public static readonly AMBER_ORANGE_50 = "#fcf3eb";

  public static readonly AMBER_ORANGE_100 = "#fae8d8";

  public static readonly AMBER_ORANGE_200 = "#f5d0b0";

  public static readonly AMBER_ORANGE_300 = "#f0b989";

  public static readonly AMBER_ORANGE_400 = "#eba161";

  public static readonly AMBER_ORANGE_500 = "#e68a3a";

  public static readonly AMBER_ORANGE_600 = "#b86e2e";

  public static readonly AMBER_ORANGE_700 = "#8a5323";

  public static readonly AMBER_ORANGE_800 = "#5c3717";

  public static readonly AMBER_ORANGE_900 = "#2e1c0c";

  public static readonly MAGENTA_25 = "#fcf7fa";

  public static readonly MAGENTA_50 = "#f9eef5";

  public static readonly MAGENTA_100 = "#f3ddeb";

  public static readonly MAGENTA_200 = "#e7bbd7";

  public static readonly MAGENTA_300 = "#da9ac2";

  public static readonly MAGENTA_400 = "#ce78ae";

  public static readonly MAGENTA_500 = "#c2569a";

  public static readonly MAGENTA_600 = "#9b457b";

  public static readonly MAGENTA_700 = "#74345c";

  public static readonly MAGENTA_800 = "#4e223e";

  public static readonly MAGENTA_900 = "#27111f";

  // Legacy Colours

  public static readonly WHITE = "#ffffff";

  public static readonly ROADMAP_MILESTONE_BLUE = "#c3c1d2";

  public static readonly ROADMAP_MILESTONE_CORAL = "#ffddd2";

  public static readonly ROADMAP_MILESTONE_CYAN = "#d5eef5";

  public static readonly ROADMAP_MILESTONE_GREEN = "#d9ece2";

  public static readonly ROADMAP_MILESTONE_COLORS = [
    ColorConstants.INDIGO_200,
    ColorConstants.CORAL_200,
    ColorConstants.AQUA_200,
    ColorConstants.GREEN_200,
    ColorConstants.ROADMAP_MILESTONE_BLUE,
    ColorConstants.ROADMAP_MILESTONE_CORAL,
    ColorConstants.ROADMAP_MILESTONE_CYAN,
    ColorConstants.ROADMAP_MILESTONE_GREEN,
  ];

  public static readonly ROADMAP_MILESTONE_COLOR_MAP: Record<string, string> = {
    [ColorConstants.INDIGO_200]: ColorConstants.INDIGO_500,
    [ColorConstants.ROADMAP_MILESTONE_BLUE]: ColorConstants.INDIGO_400,
    [ColorConstants.CORAL_200]: ColorConstants.CORAL_500,
    [ColorConstants.ROADMAP_MILESTONE_CORAL]: ColorConstants.CORAL_400,
    [ColorConstants.AQUA_200]: ColorConstants.AQUA_500,
    [ColorConstants.ROADMAP_MILESTONE_CYAN]: ColorConstants.AQUA_400,
    [ColorConstants.GREEN_200]: ColorConstants.GREEN_500,
    [ColorConstants.ROADMAP_MILESTONE_GREEN]: ColorConstants.GREEN_400,
  };

  public static readonly LINE_CHART_COLORS = [ColorConstants.INDIGO_500_RGB, ColorConstants.GREEN_500_RGB];

  public static readonly CHART_COLORS = [
    ColorConstants.INDIGO_500,
    ColorConstants.GREEN_500,
    ColorConstants.CORAL_500,
    ColorConstants.GOLDENROD_500,
    ColorConstants.BLUE_500,
    ColorConstants.MAGENTA_500,
    ColorConstants.AQUA_500,
    ColorConstants.VIOLET_500,
    ColorConstants.GREY_500,
  ];

  public static readonly CHART_HIGHLIGHT_COLORS = [
    ColorConstants.INDIGO_400,
    ColorConstants.GREEN_400,
    ColorConstants.CORAL_400,
    ColorConstants.GOLDENROD_400,
    ColorConstants.BLUE_400,
    ColorConstants.MAGENTA_400,
    ColorConstants.AQUA_400,
    ColorConstants.VIOLET_400,
    ColorConstants.GREY_400,
  ];

  public static readonly CHART_COLORS_VVB = [
    ColorConstants.CORAL_500,
    ColorConstants.GOLDENROD_500,
    ColorConstants.GREEN_500,
  ];

  public static readonly CHART_HIGHLIGHT_COLORS_VVB = [
    ColorConstants.CORAL_400,
    ColorConstants.GOLDENROD_400,
    ColorConstants.GREEN_400,
  ];

  public static readonly CHART_COLORS_DISCUSSIONS = [
    ColorConstants.GREEN_400,
    ColorConstants.CORAL_500,
    ColorConstants.CORAL_200,
  ];

  public static readonly CHART_HIGHLIGHT_COLORS_DISCUSSIONS = [
    ColorConstants.GREEN_300,
    ColorConstants.CORAL_400,
    ColorConstants.CORAL_100,
  ];

  public static readonly CHART_GRADIENT_COLORS = [
    [ColorConstants.INDIGO_500, ColorConstants.INDIGO_100],
    [ColorConstants.GREEN_500, ColorConstants.GREEN_100],
    [ColorConstants.CORAL_500, ColorConstants.CORAL_100],
    [ColorConstants.GOLDENROD_500, ColorConstants.GOLDENROD_100],
    [ColorConstants.BLUE_500, ColorConstants.BLUE_100],
    [ColorConstants.MAGENTA_500, ColorConstants.MAGENTA_100],
    [ColorConstants.AQUA_500, ColorConstants.AQUA_100],
    [ColorConstants.VIOLET_500, ColorConstants.VIOLET_100],
    [ColorConstants.GREY_500, ColorConstants.GREY_100],
  ];

  public static readonly CHART_GRADIENT_HIGHLIGHT_COLORS = [
    ColorConstants.INDIGO_500,
    ColorConstants.GREEN_500,
    ColorConstants.CORAL_500,
    ColorConstants.GOLDENROD_500,
    ColorConstants.BLUE_500,
    ColorConstants.MAGENTA_500,
    ColorConstants.AQUA_500,
    ColorConstants.VIOLET_500,
    ColorConstants.GREY_500,
  ];

  public static readonly CHART_ROADMAP_COLORS = [
    ColorConstants.INDIGO_500,
    ColorConstants.CORAL_500,
    ColorConstants.AQUA_500,
    ColorConstants.GREEN_500,
    ColorConstants.GREY_300,
  ];

  public static readonly CHART_ROADMAP_HIGHLIGHT_COLORS = [
    ColorConstants.INDIGO_500,
    ColorConstants.CORAL_500,
    ColorConstants.AQUA_500,
    ColorConstants.GREEN_500,
    ColorConstants.GREY_300,
  ];

  public static readonly CHART_GRADIENT_ROADMAP_COLORS = [
    [ColorConstants.INDIGO_500, ColorConstants.INDIGO_100],
    [ColorConstants.CORAL_500, ColorConstants.CORAL_100],
    [ColorConstants.AQUA_500, ColorConstants.AQUA_100],
    [ColorConstants.GREEN_500, ColorConstants.GREEN_100],
    [ColorConstants.GREY_300, ColorConstants.GREY_100],
  ];
}
